import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { branch, compose, getContext, withProps } from 'recompose'
import { selectCurrentCELs } from 'src/store/selectors/home/dictionary'
import { sampleLoan } from 'src/constants/homePreview'
import { selectInterestDiff } from 'src/store/selectors/home/loans'
import { selectLowestRefiRate } from 'src/store/selectors/mortgageRate'
import {
  MONTHS_IN_YEAR,
  LOWEST_INTEREST_REFI_TERM
} from 'src/constants/refinance'

const contextTypes = {
  withCurrentHomeData: PropTypes.bool,
  locked: PropTypes.bool
}

const composeWithHomeData = compose(
  connect(state => {
    const dictionary = selectCurrentCELs(state)
    const rate = selectLowestRefiRate(state)
    const periods = LOWEST_INTEREST_REFI_TERM * MONTHS_IN_YEAR

    return {
      loans: dictionary.loans(),
      interestStatus: dictionary.interestStatus({ rate, periods }),
      interestTotal: dictionary.interestForFullLoanTotal(),
      interestDiff: selectInterestDiff(state)
    }
  })
)

const composeWithoutHomeData = compose(
  withProps(() => ({
    interestStatus: '',
    interestTotal: sampleLoan.facts.totalInterest,
    interestDiff: sampleLoan.facts.interestDiff,
    loans: [sampleLoan]
  }))
)

const StatusExplainerContainer = compose(
  getContext(contextTypes),
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  )
)

export default StatusExplainerContainer
